import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

export function BookShipmentInsuranceQuestionBubble() {
  return (
    <Tooltip
      interactive
      variant="info"
      content={
        <Stack gap={2}>
          <T weight="bold">Insurance</T>
          <T size="xs" color="secondary">
            Adding insurance helps protect your shipment in the event of a
            claim. Insurance is provided by our reputable insurance partner, and
            all insurance comes with a $500 deductible. Please open a live chat
            for more details.
          </T>
          <Link
            href="https://help.freightsimple.com/using-freightsimple/quoting/insurance"
            external
          >
            Learn more
          </Link>
        </Stack>
      }
    />
  );
}
